module.exports = __webpack_public_path__ + "static/img/7.42fc559.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/7.png
// module id = Kt8G
// module chunks = 0